// store/index.js
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import aplusSlice from './slices/aplus';
import authUserSlice from './slices/authUser';
import productSlice from './slices/product';
import signupUserSlice from './slices/signupUser';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['auth','aplusSlice','productSlice'],
};

const rootReducer = combineReducers({
  auth: authUserSlice,
  productSlice:productSlice,
  aplusSlice:aplusSlice,
  signupUserSlice:signupUserSlice
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types from redux-persist
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['register', 'rehydrate'],
        // Ignore these paths in the state
        ignoredPaths: ['register', 'rehydrate'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;